module.exports = __webpack_public_path__ + "assets/img/38_419_big.7ff9fb18.jpg";